import { render } from "./AppSeparator.vue?vue&type=template&id=3b035b02&scoped=true"
const script = {}

import "./AppSeparator.vue?vue&type=style&index=0&id=3b035b02&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b035b02"]])

export default __exports__